import { Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";

export default function CardImageList(props: any) {
    const [imagem, setImagem] = useState("");

    function changeImage(){
    if(props.text.toLowerCase() === "mastercard"){
        setImagem("/card_brands/mastercard.svg")
    }
    if(props.text.toLowerCase() === "visa"){
        setImagem("/card_brands/visa.svg")
    }
    if(props.text.toLowerCase() === "american express"){
        setImagem("/card_brands/amex.svg")
    }
    if(props.text.toLowerCase() === "aura"){
        setImagem("/card_brands/aura.png")
    }
    if(props.text.toLowerCase() === "banescard"){
        setImagem("/card_brands/banescard.svg")
    }
    if(props.text.toLowerCase() === "boleto"){
        setImagem("/card_brands/boletos.svg")
    }
    if(props.text.toLowerCase() === "diners club"){
        setImagem("/card_brands/diners.svg")
    }
    if(props.text.toLowerCase() === "discover"){
        setImagem("/card_brands/discover.svg")
    }
    if(props.text.toLowerCase() === "discover"){
        setImagem("/card_brands/discover.svg")
    }
    if(props.text.toLowerCase() === "elo"){
        setImagem("/card_brands/elo.svg")
    }
    if(props.text.toLowerCase() === "hipercard"){
        setImagem("/card_brands/hipercard.svg")
    }
    if(props.text.toLowerCase() === "jcb"){
        setImagem("/card_brands/jcb.png")
    }
    if(props.text.toLowerCase() === "maestro"){
        setImagem("/card_brands/maestro.svg")
    }
    if(props.text.toLowerCase() === "pix"){
        setImagem("/card_brands/pix.png")
    }
    if(props.text.toLowerCase() === "visa electron"){
        setImagem("/card_brands/visa-electron.svg")
    }
    if(props.text.toLowerCase() === "sorocred"){
        setImagem("/card_brands/sorocred.svg")
    }
    if(props.text.toLowerCase() === "cabal"){
        setImagem("/card_brands/cabal.svg")
    }
    }
    useEffect(()=>{
        changeImage();
    },[props.text])

    return (
        <>
            <Flex flexDirection={"row"} alignItems={"center"}>
                <img
                    style={{
                        maxWidth: "1.75em",
                        maxHeight: "auto",
                        marginRight: ".5em",
                        verticalAlign: "middle",
                    }}
                    src={imagem}
                    alt={""}
                />
                {props.children}
            </Flex>
        </>
    );
}
